import _ from 'lodash';
import { GAME_ID, REDUX_ACTIONS, QUESTIONS_COUNT_PER_LEVEL } from 'a/zoomBoom/data/constants';

const initialState = {
  highestLevelEarned: 0,
  wasOnboardingPlayed: false,
  level: -1,
  question: -1,
  currentLevelWordGroups: [],
  correctAnswersCount: 0,
  firstAnswerWrong: false,
};

const questionReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL: {
      const { level, wordGroups } = payload;
      const dupWordGroups = wordGroups.reduce((memo, el) => memo.concat([el, el]), []);
      return {
        ...state,
        level,
        question: 0,
        currentLevelWordGroups: _.shuffle(dupWordGroups),
        correctAnswersCount: 0,
      };
    }

    case REDUX_ACTIONS.UNLOCK_LEVEL:
      return {
        ...state,
        highestLevelEarned: payload,
      };

    case REDUX_ACTIONS.SET_ONBOARDING_WAS_PLAYED:
      return {
        ...state,
        wasOnboardingPlayed: true,
      };

    case REDUX_ACTIONS.LOAD_SAVED_DATA:
      return {
        ...state,
        wasOnboardingPlayed: payload.wasOnboardingPlayed,
      };

    case REDUX_ACTIONS.GET_NEXT_QUESTION:
      return {
        ...state,
        question: state.question + 1,
        firstAnswerWrong: false,
      };

    case REDUX_ACTIONS.INCREASE_CORRECT_ANSWERS_COUNT:
      return {
        ...state,
        correctAnswersCount: state.firstAnswerWrong
          ? state.correctAnswersCount
          : state.correctAnswersCount + 1,
      };

    case REDUX_ACTIONS.ANSWER_INCORRECTLY:
      return {
        ...state,
        firstAnswerWrong: true,
      };

    case REDUX_ACTIONS.QUICK_ROUND: {
      const numCorrect = payload ? QUESTIONS_COUNT_PER_LEVEL : 0;
      return {
        ...state,
        correctAnswersCount: numCorrect,
        question: QUESTIONS_COUNT_PER_LEVEL - 1,
      };
    }

    default:
      return state;
  }
};

export default questionReducer;
